import React, { createContext, useContext } from 'react';

const ActiveMenuContext = createContext({ activeMenu: '', setActiveMenu: () => {} });

export const useActiveMenu = () => useContext(ActiveMenuContext);

export { ActiveMenuContext };
